import React from "react";
import ManageBookings from "./ManageBookings";

const ManageCompletedBookings = () => {
    return (<ManageBookings bookingStatus='COMPLETED' title='Completed Bookings'/>)
}

export default ManageCompletedBookings;
